export default {
  common: {
    search: 'Search',
    fixHead: 'Freeze the header',
    cancelFix: 'Unfreeze',
    downloadData: 'Download',
    copyData: 'Copy',
    download: 'Download',
    copy: 'Copy',
    reset: 'Reset',
    find: 'Search',
    noData: 'No Data',
    selected: 'Selected ',
    today: "Today",
    yesterday: "Yesterday",
    '2DaysAgoT': "Two Days Ago",
    yesterdayT: "One Day Ago",
    chart: "Chart",
    table: "Table",
    date: "Date",
    currentPeriod: "Current",
    monthPeriod: "Term-to-Term",
    yearPeriod: "YoY",
    minute: "minute",
    minuteU: "Minute",
    time: "time",
    timeU: "Time",
    day: "day",
    clear: "Clear",
    selectDate: "Select Date",
    date: 'Date',
    logout: 'Logout',
    nongameP: 'Non-game',
    gameP: 'Game',
    value: 'Value',
    month: "month",
    monthTime: "Month",
    week: "week",
    weekTime: "Week",
    year: "year",
    yearTime: "Year",
  },
  ux: {
    uxtools: 'UXTools',
  },
  searchBar: {
    empty: 'No Data'
  },
  pageHeader: {
    saveSetting: 'Save My Settings',
    gameSpec: 'Special page',
    demandFollow: 'Demand follow-up',
    dataDevelop: 'Data development',
    qa: 'QA',
    offline: 'offline page',
    pageConfig: 'page config',
    checkAll: 'Check all',
    server: "Server",
    serverPlaceholder: 'Default (All Servers)',
    serverList: 'Server List',
    area: "Area",
    crossServerList: 'Cross & Merger Server list',
    mustFill: 'This field must be filled in'
  },
  chartTrans: {
    xAxis: 'xAxis',
    yAxis: 'yAxis',
    compare: 'compare',
  },
  chart: {
    showAllLegend: 'show all legend',
    hideAllLegend: 'hide all legend',
  },
  dataTable: {
    totalInfo: 'A total of {0} records. No. {1}',
    summary: "Total"
  },
  fixed: {
    calculating: "Calculating...",
    noData: 'No data available',
    loading: "Loading...",
    all: "All",
    android: "Android",
    androidS: 'AN',
    setDate: 'Add comparison date',
    setYear: 'Add comparison year',
    realtime: {
      name: "Live Stats",
      title: "Live Stats",
      overview: {
        title: "Overview",
        dataPay: "Total Income",
        dataNew: "New Users",
        dataDau: "DAU",
      },
      online: {
        title: "Concurrent Users",
        time: "Time",
        cnt: "User Total",
        deviceTitle: "Concurrent Devices"
      },
      conversion: {
        title: "In-Game Stage Conversion Rate",
        device: " Devices",
        retention: " Retained",
        allChannel: "All",
        overall: "Overall",
        stage: "By Stage",
        inConversion: "Login Conversion"
      }
    },
    pay: {
      name: "Payment",
      title: "Payment",
      overview: {
        title: "Payment Data Overview",
        dataCash: "Amount Recharged",
        dataPayAccCnt: "Unique Recharges",
        dataPayRatio: "Users Recharging",
        dataArpu: "ARPU"
      },
      structure: {
        title: "Payment",
        amount: "Amount Recharged",
        login: "Total Logins",
        rate: "Proportion",
        vipLevel: "VIP Level",
        remark: "Note",
        totalRechargePercentage: "Total Recharge Proportion",
        statisticalRechargePercentage: "Recharge Proportion (Current Term)",
        contributions: "Total Recharge Amount (Current Term)",
        loginPercentage: "Login Proportion",
        Unlogin: "7-Day Inactive Rate",
        total: "Total",
        wastage: "Churn Rate"
      },
      ltv: {
        title: "Daily New User LTV",
        newAccCount: "New Users",
        accCount: "Users",
        ltv1: "1-Day User LTV",
        ltv3: "3-Day User LTV",
        ltv7: "7-Day User LTV",
        ltv15: "15-Day User LTV",
        ltv30: "30-Day User LTV"
      }
    },
    report: {
      name: "Operations Reports",
      title: "Operations Reports",
      overview: {
        title: "Overview",
        dataCash: "Amount Recharged",
        dataPayAccount: "Unique Recharges",
        dataNew: "New Users",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        lastWeek: "Last Week",
        weekCount: "Week {count}"
      }
    },
    new: {
      name: "Retention Info",
      title: "Retention Info",
      min: "mins",
      overview: {
        title: "Overview",
        dataAccCnt: "New Users",
        dataRoleCnt: "Characters Created"
      },
      liucun: {
        title: "User/Character Retention",
        accTitle: "New User Retention",
        roleTitle: "New Character Retention",
        dataAccCnt: "New Users",
        dataRoleCnt: "New Characters"
      },
      week_liucun: {
        title: "Week New User Retention",
        week: "Week",
        week_1: "This Week",
        week_2: "Next Week",
        week_3: "3rd Week",
        week_4: "4th Week",
        week_5: "5th Week",
      },
      minuteReach: {
        title: "Playtime After Character Creation",
        ratio: "Percentage",
        min: "Time (Min)"
      },
      minuteReachTrend: {
        title: "Playtime After Character Creation Over Time",
        ratio_5: "5 Min",
        ratio_15: "15 Min",
        ratio_30: "30 Min",
        ratio_60: "60 Min",
        ratio_90: "90 Min",
        ratio_120: "120 Min",
        ratio: "Retention Rate"
      }
    },
    online: {
      name: "Active Users",
      title: "Active Users",
      cnt: "Character Count",
      overview: {
        title: "Overview",
        dataAccCnt: "Active Users",
        dataDeviceCnt: "Active Devices",
        dataRoleCnt: "Active Characters"
      },
      online: {
        title: "Concurrent Users",
        time: "Time",
        cnt: "User Total"
      },
      level: {
        title: "Level Distribution",
        level: "Level"
      },
      class: {
        title: "Class Distribution",
        class: "Class"
      },
      map: {
        title: "DAU Distribution Map",
        world: "Global",
        china: "China",
        area: "Area",
        cnt: "User Total",
      }
    },
    experience: {
      title: 'UX Experience',
    },
    veteran: {
      title: 'History Users',
    },
    fashion: {
      title: 'Fashion',
    },
    test: {
      title: 'Test',
    },
    reflow: {
      title: 'Reflow'
    },
    version: {
      title: 'Version'
    },
    consume: {
      title: 'Consume'
    },
    subjects: {
      title: "Game Specific",
    }
  },
  day: {
    day_2: "2nd day",
    day_3: "3rd day",
    day_4: "4th day",
    day_5: "5th day",
    day_6: "6th day",
    day_7: "7th day",
    day_8: "8th day",
    day_9: "9th day",
    day_10: "10th day",
    day_11: "11th day",
    day_12: "12th day",
    day_13: "13th day",
    day_14: "14th day",
    day_15: "15th day",
    day_30: "30th day"
  },
  week: {
    short_1: "Mon",
    short_2: "Tue",
    short_3: "Wed",
    short_4: "Thu",
    short_5: "Fri",
    short_6: "Sat",
    short_7: "Sun"
  },
  month: {
    long_1: "January",
    long_2: "February",
    long_3: "March",
    long_4: "April",
    long_5: "May",
    long_6: "June",
    long_7: "July",
    long_8: "August",
    long_9: "September",
    long_10: "October",
    long_11: "November",
    long_12: "December",
    long_other: "Unknown",
    short_1: "Jan.",
    short_2: "Feb.",
    short_3: "Mar.",
    short_4: "Apr.",
    short_5: "May",
    short_6: "June",
    short_7: "July",
    short_8: "Aug.",
    short_9: "Sept.",
    short_10: "Oct.",
    short_11: "Nov.",
    short_12: "Dec.",
    short_other: "Ukn"
  },
};
